import PageHero from "../components/PageHero";
import EligibilitySection from "../sections/EligibilitySection";
import { usePageMeta } from "../lib/motion";
import { IMAGES } from "../data/content";

const EligibilityPage = () => {
  usePageMeta("Check Your Visa Eligibility", "Use The Trip World's eligibility checker for a preliminary assessment of your visa profile.");
  return (
    <main data-testid="eligibility-page">
      <PageHero
        eyebrow="ELIGIBILITY"
        title="CHECK YOUR VISA"
        highlight="ELIGIBILITY"
        description="Share your profile and our team will review your details and guide you on suitable next steps. A preliminary assessment only — final decisions rest with the relevant immigration authority."
        image={IMAGES.eligibility}
      />
      <div className="py-20 lg:py-28 bg-navy-deep">
        <EligibilitySection compact />
      </div>
    </main>
  );
};

export default EligibilityPage;
